import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);

/** 기간안에 특정 일자가 포함되는지 여부를 반환하는 함수 */
export default function isDateWithinPeriod(
  targetDate: string,
  useBeginDtm: string,
  useEndDtm?: string
) {
  if (useEndDtm) {
    return dayjs(targetDate).isBetween(useBeginDtm, useEndDtm, "minute", "[)");
  } else {
    return dayjs(targetDate).isSameOrAfter(useBeginDtm, "minute");
  }
}
